import React from 'react';
import { handleResponse } from '../../../../helpers/handleresponse';

class StyleWrapper extends React.Component {
    state = {
        text: ''
    }
    componentDidMount() {
        setTimeout(() => this.replaceTags(), 500);
    }
     componentDidUpdate(prevProps){
        if(this.props.content != prevProps.content){
            setTimeout(() => this.replaceTags(), 500);
        }
    }
    replaceTags = () => {
        const { content, isPage, order, lang } = this.props;
        if (order && content && isPage) {
            const requestOptions = {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text: content, orderId: order.orderId, eventId: order.eventId, lang: (lang || order.languageCode || 'swe') })
            };
            fetch(`./api/page/tagreplace`, requestOptions)
                .then(handleResponse)
                .then(res => {
                    this.setState({ text: res.text });
                });
        }
        else {
            this.setState({ text: content })
            if(window.location.search && window.location.search.toLowerCase().includes("badgeno")){
                setTimeout(() => this.replaceTags(), 500)
            }
        }
    }
    render() {
        const { template, content, isHeaderText, select, isPage, order } = this.props;
        return (
            <React.Fragment>
                <style>

                    {template}
                </style>
                <div onClick={select} className={`content-parent ${isHeaderText ? 'responsive-header-text' : ''}`} style={{ width: '100%' }} dangerouslySetInnerHTML={
                    { __html: this.state.text }
                } />
            </React.Fragment>
        )
    }
}
export default StyleWrapper;

